var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThought(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 14.875C38 11.009 34.866 7.875 31 7.875C29.833 7.875 28.735 8.165 27.768 8.669C25.686 5.842 22.343 4 18.563 4C13.431 4 9.088 7.38 7.64 12.036C4.982 12.653 3 15.03 3 17.875C3 20.854 5.174 23.32 8.021 23.788C8.237 27.737 11.498 30.875 15.5 30.875C17.676 30.875 19.63 29.942 21 28.462C22.37 29.942 24.323 30.875 26.5 30.875C30.643 30.875 34 27.518 34 23.375C34 22.665 33.895 21.981 33.711 21.33C36.23 20.271 38 17.78 38 14.875Z",
    fill: "#85C8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 36.875C8.65685 36.875 10 35.5319 10 33.875C10 32.2181 8.65685 30.875 7 30.875C5.34315 30.875 4 32.2181 4 33.875C4 35.5319 5.34315 36.875 7 36.875Z",
    fill: "#85C8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThought);
export default __webpack_public_path__ + "static/media/thought.f07c8ec33f923f54ea55a925bfda5336.svg";
export { ForwardRef as ReactComponent };